import React, { Component } from 'react';
import { connect } from 'react-redux';
import { unitTransform, unitLabel } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '@texts';
import { Table } from 'reactstrap';
import './styles.scss';

class CalculateEurocode5Design extends Component {

  render() {
    const { selectedNail, loadUnit } = this.props;
    const unitLbl = unitLabel(loadUnit);

    return (
      <section className="list-type calculate-eurocode5-design">
        <Table bordered size="sm">
          <tbody>
            <tr>
              <th scope="row">{APP_TEXTS.CALCULATE_EUROCODE5_LOADS_ON_NAILS.Content}</th>
              <td>
                {selectedNail && selectedNail.Fax_d ?
                  unitTransform(selectedNail.Fax_d, true)
                    .from(defaultUnits.LOAD)
                    .to(loadUnit)
                    .toFixed(2) : 0
                }
              </td>
              <td>{unitLbl}</td>
            </tr>
            <tr>
              <th scope="row">{APP_TEXTS.CALCULATE_EUROCODE5_FRD.Content}</th>
              <td>
                {selectedNail && selectedNail.FRd ?
                  unitTransform(selectedNail.FRd, true)
                    .from(defaultUnits.LOAD)
                    .to(loadUnit)
                    .toFixed(2) : 0
                }
              </td>
              <td>{unitLbl}</td>
            </tr>
          </tbody>
        </Table>
      </section>
    );
  }

}

const mapState = state => {
  const calculate = state.selectors.calculate[state.main.appType];
  return {
    selectedNail: calculate ? calculate.gridSelectedNailItem : null,
    loadUnit: state.main.units.load
  };
};

export default connect(mapState)(CalculateEurocode5Design); 



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateEurocode5Design/index.js